import Vuex from 'vuex';
import Vue from 'vue';
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);
const state = {
  user: null
};

const mutations = {
  _login (state, payload) {
    state.user = payload.user;
  },
  _updateLoginTimeStamp (state, payload) {
    state.loginTimeStamp = payload.loginTimeStamp;
  },
  _logout (state) {
    state.user = null;
  },
  _updateLoggedInName (state, payload) {
    state.user.name = payload.name;
  },
  _updateLoggedInCompanyAdd (state, payload) {
    state.user.company_address = payload.company_address;
  },
  _updateUserProfilePic (state, payload) {
    state.user.user_profile_pic = payload.userProfilePic;
  },
  _updateLoggedInEmail (state, payload) {
    state.user.email = payload.email;
  },
  _updateLoggedInAltPhone (state, payload) {
    state.user.alternate_phone_no = payload.altPhoneNumber;
  },
  _updateLoggedInContactPhone (state, payload) {
    state.user.contact_phone_no = payload.contactPhoneNumber;
  },
  _updateLoggedInAddress (state, payload) {
    state.user.address = payload.address;
  },
  _updateLoggedInPin (state, payload) {
    state.user.pin_no = payload.pin;
  },
  _updateLoggedInTmpPin (state, payload) {
    state.user.pin_no_tmp = payload.pin;
  },
  _updateLoginType (state, payload) {
    state.loginType = payload.loginType;
  },
  _updateLoggedInMaxTalkClicked (state, payload) {
    state.user.is_maxtalk_clicked = payload.maxTalkClicked;
  }
};

const actions = {
  saveToken ({ commit, state }, { token }) {
    commit('_saveToken', { token });
  },
  savePermissions ({ commit, state }, { permissions }) {
    commit('_savePermissions', { permissions });
  },
  login ({ commit, state }, { user }) {
    commit('_login', { user });
  },
  updateLoginTimeStamp ({ commit, state }, { loginTimeStamp }) {
    commit('_updateLoginTimeStamp', { loginTimeStamp });
  },
  updateLoggedInName ({ commit, state }, { name }) {
    commit('_updateLoggedInName', { name });
  },
  updateLoggedInCompanyAdd ({ commit, state }, { company_address }) {
    commit('_updateLoggedInCompanyAdd', { company_address });
  },
  updateUserProfilePic({ commit, state }, { userProfilePic }) {
    commit('_updateUserProfilePic', { userProfilePic });
  },
  updateLoggedInEmail ({ commit, state }, { email }) {
    commit('_updateLoggedInEmail', { email });
  },
  updateLoggedInAltPhone ({ commit, state }, { altPhoneNumber }) {
    commit('_updateLoggedInAltPhone', { altPhoneNumber });
  },
  updateLoggedInContactPhone ({ commit, state }, { contactPhoneNumber }) {
    commit('_updateLoggedInContactPhone', { contactPhoneNumber });
  },
  updateLoggedInAddress ({ commit, state }, { address }) {
    commit('_updateLoggedInAddress', { address });
  },
  updateLoggedInPin ({ commit, state }, { pin }) {
    commit('_updateLoggedInPin', { pin });
  },
  updateLoggedInTmpPin ({ commit, state }, { pin }) {
    commit('_updateLoggedInTmpPin', { pin });
  },
  logout ({ commit }) {
    commit('_logout');
  },
  updateLoginType ({ commit, state }, { loginType }) {
    commit('_updateLoginType', { loginType });
  },
  updateLoggedInMaxTalkClicked ({ commit, state }, { maxTalkClicked }) {
    commit('_updateLoggedInMaxTalkClicked', { maxTalkClicked });
  },
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  plugins: [createPersistedState()]
});



// WEBPACK FOOTER //
// ./src/store/index.js